import * as React from "react";
import {FunctionComponent, useEffect, useState} from "react";
import {
  Button,
  Checkbox,
  Chip,
  CircularProgress,
  FormControl,
  Grid,
  InputBase,
  ListItemText,
  MenuItem,
  NativeSelect,
  Select,
  Typography,
} from "@material-ui/core";
import {createStyles, makeStyles, Theme, withStyles,} from "@material-ui/core/styles";
import {TestDashboard} from "./test-dashboard/testDashboard";
import {ParameterConfig} from "./parameter-configuration/parameterConfig";
import {DeviceConfig} from "./device-configuration/deviceConfig";
import {
  formatDateString,
  getAllBatches,
  getAllDefaultMainTestCases,
  getAllDevices,
  getAllMainTestCases,
  getDeviceTestSummery,
  getTestCondition,
} from "./api-helper/apiHelper";
import {TextBar} from "../../components/sub-components/TextBar";
import { primaryBlue, primaryGray, white } from "src/components/colors";
import useStyles from "src/app/maintenance/assets/styles";
import { DateTimeSelectorComponent } from "../maintenance/test-automation/components/DateTimeSelector";

const localStyles = makeStyles((theme: Theme) => ({
  navButtons: {
    height: "55px",
    alignContent:"center",
    fontSize: "14px",
    cursor: "pointer",
  },
  text: {
    fontSize: "14px",
    color: "#5E5873",
    marginBottom: "10px",
  },
  dropdown: {
    width: "100%",
    height: "40px",
    backgroundColor: "#F4F5F7",
  },
  menuPaper: {
    maxHeight: "200px",
  },
  chip: {
    borderRadius: "4px",
    backgroundColor: "#C7C4C436",
    marginLeft: "5px",
  },
}));

export const TestingAutomationComponent: FunctionComponent = () => {
  const classes = localStyles();
  const style = useStyles();
  const [step, setStep] = useState("device");
  const [devices, setDevices] = useState([]);
  const [constDevices, setConstDevices] = useState([]);
  const [batches, setBatches] = useState(["No batches found"]);
  const [mainTestCases, setMainTestCases] = useState([]);
  const [allMainTestData, setAllMainTestData] = useState([]);
  const [allSubTestCases, setAllSubTestCases] = useState([]);
  const [testSummary, setTestSummary] = useState();
  const [allTestConditions, setAllTestConditions] = useState([]);

  const [selectedBatch, setSelectedBatch] = useState("Select the batch");
  const [selectedMainTestCase, setSelectedMainTestCase] = useState(
    "Select the test case"
  );
  const [selectedDevice, setSelectedDevice] = useState([]);
  const [selectedSubTestCase, setSelectedSubTestCase] = useState([]);
  const [filteredSubTestCaseIds, setFilteredSubTestCaseIds] = useState([]);
  const [selectedTestCondition, setSelectedTestCondition] = useState([]);

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [loading, setLoading] = useState(false);
  const [loadingTestSummary, setLoadingTestSummary] = useState(false);
  const [previousBatch, setPreviousBatch] = useState("");
  const [testSuccessData, setTestSuccessData] = useState([]);
  const [dataTableMainTestCases, setDataTableMainTestCases] = useState([]);
  const [mainTestCaseTitle, setMainTestCaseTitle] = useState("");
  const [selectedMainDefaultTestCase, setSelectedMainDefaultTestCase] = useState("");
  const [subTestCasesOfTheTest, setSubTestCasesOfTheTest] = useState({mainTestTitle: ""})
  const [selectedStartDate,setSelectedStartDate] = useState(new Date())
  const [selectedEndDate,setSelectedEndDate] = useState(new Date())

  const setSubTestCasesForParameter = (subCases) => {
    setSubTestCasesOfTheTest(subCases)
  }

  const cancel = () => {
    setSelectedDevice([]);
    setSelectedTestCondition([]);
    setSelectedSubTestCase([]);
    setFilteredSubTestCaseIds([]);
    setSelectedBatch("Select the batch");
  };
  const selectBatch = async (e) => {
    e.persist();
    setLoading(true);
    setSelectedBatch(e.target.value);
    setMainTestCases([]);
    setAllMainTestData([]);
    setAllSubTestCases([]);
    setSelectedDevice([]);
    setLoading(true);
    let newDevices = [];

    constDevices.map((device) => {
      if (e.target.value != "") {
        if (device.batchNumber == e.target.value) {
          newDevices.push(device);
        }
      }
    });
    if (e.target.value == "") {
      setLoading(false);
    }
    setDevices(newDevices);

    if (step === "parameter") {
      const testSuccessCriteria = await getAllMainTestCases(e.target.value);

      if (testSuccessCriteria != undefined) {
        setTestSuccessData(testSuccessCriteria.data);
      }

      if (
        testSuccessCriteria.mainTestCases.length > 0 &&
        testSuccessCriteria.data.length > 0
      ) {
        setSelectedMainTestCase(testSuccessCriteria.data[0].id);
        setSelectedMainDefaultTestCase(testSuccessCriteria.data[0].id);
        setMainTestCaseTitle(testSuccessCriteria.data[0].mainTestTitle);
        setMainTestCases(testSuccessCriteria.mainTestCases);
        setAllMainTestData(testSuccessCriteria.data);
        setAllSubTestCases(testSuccessCriteria.data[0].subTestCases);
        setSelectedSubTestCase(
          [{
            id: testSuccessCriteria.data[0].subTestCases[0].id,
            subTestTitle: testSuccessCriteria.data[0].subTestCases[0].subTestTitle
          }]
        );
        setFilteredSubTestCaseIds(testSuccessCriteria.data[0].subTestCases[0].id);
      } else {
        const mainTestCasesData = await getAllDefaultMainTestCases();
        if (mainTestCasesData !== undefined) {
          setSelectedMainTestCase(mainTestCasesData.data[0].id);
          setSelectedMainDefaultTestCase(mainTestCasesData.data[0].id);
          setMainTestCaseTitle(mainTestCasesData.data[0].mainTestTitle);
          setMainTestCases(mainTestCasesData.mainTestCases);
          setAllMainTestData(mainTestCasesData.data);
          setAllSubTestCases(mainTestCasesData.data[0].subTestCases);
          setSelectedSubTestCase(
            [{
              id: mainTestCasesData.data[0].subTestCases[0].id,
              subTestTitle: mainTestCasesData.data[0].subTestCases[0].subTestTitle
            }]
          );
          setFilteredSubTestCaseIds(mainTestCasesData.data[0].subTestCases[0].id);
        }
      }
    }

    if (step === "test") {
      const testSummery = await getDeviceTestSummery(e.target.value, subTestCasesOfTheTest.mainTestTitle);
      if (testSummery !== undefined) {
        setTestSummary(testSummery);
      }
      const testSuccessCriteria = await getAllMainTestCases(e.target.value);

      if (testSuccessCriteria != undefined) {
        setTestSuccessData(testSuccessCriteria.data);
      }

      if (
        testSuccessCriteria.mainTestCases.length > 0 &&
        testSuccessCriteria.data.length > 0
      ) {
        setSelectedMainTestCase(testSuccessCriteria.data[0].id);
        setMainTestCases(testSuccessCriteria.mainTestCases);
        setAllMainTestData(testSuccessCriteria.data);
        setAllSubTestCases(testSuccessCriteria.data[0].subTestCases);
        setSelectedSubTestCase(
          [{
            id: testSuccessCriteria.data[0].subTestCases[0].id,
            subTestTitle: testSuccessCriteria.data[0].subTestCases[0].subTestTitle
          }]
        );
        setFilteredSubTestCaseIds(testSuccessCriteria.data[0].subTestCases[0].id);

      } else {
        const mainTestCasesData = await getAllDefaultMainTestCases();
        if (mainTestCasesData !== undefined) {
          setSelectedMainTestCase(mainTestCasesData.data[0].id);
          setMainTestCases(mainTestCasesData.mainTestCases);
          setAllMainTestData(mainTestCasesData.data);
          setAllSubTestCases(mainTestCasesData.data[0].subTestCases);
          setSelectedSubTestCase(
            [{
              id: mainTestCasesData.data[0].subTestCases[0].id,
              subTestTitle: mainTestCasesData.data[0].subTestCases[0].subTestTitle
            }]
          );
          setFilteredSubTestCaseIds(mainTestCasesData.data[0].subTestCases[0].id);
        }
      }
      const dataMainCases = await getAllDefaultMainTestCases();
      setDataTableMainTestCases(dataMainCases.mainTestCases);
    }

    if (step === "device") {
      const mainTestCasesData = await getAllDefaultMainTestCases();
      if (mainTestCasesData !== undefined) {
        setSelectedMainTestCase(mainTestCasesData.data[0].id);
        setSelectedMainDefaultTestCase(mainTestCasesData.data[0].id);
        setMainTestCaseTitle(mainTestCasesData.data[0].mainTestTitle);
        setMainTestCases(mainTestCasesData.mainTestCases);
        setAllMainTestData(mainTestCasesData.data);
        setAllSubTestCases(mainTestCasesData.data[0].subTestCases);
        setSelectedSubTestCase(
          [{
            id: mainTestCasesData.data[0].subTestCases[0].id,
            subTestTitle: mainTestCasesData.data[0].subTestCases[0].subTestTitle
          }]
        );
        setFilteredSubTestCaseIds(mainTestCasesData.data[0].subTestCases[0].id);
      }
      const dataMainCases = await getAllDefaultMainTestCases();
      setDataTableMainTestCases(dataMainCases.mainTestCases);
    }

    setLoading(false);
  };
  const selectMainTestCase = (e) => {
    setSelectedMainTestCase(e.target.value);
    //setSelectedMainDefaultTestCase(e.value.target);
    const index = allMainTestData.findIndex((obj) => obj.id === e.target.value);
    setMainTestCaseTitle(allMainTestData[index].mainTestTitle);
    setAllSubTestCases(allMainTestData[index].subTestCases);
    setSelectedSubTestCase(
      [{
        id: allMainTestData[index].subTestCases[0].id,
        subTestTitle: allMainTestData[index].subTestCases[0].subTestTitle
      }]
    );
    setFilteredSubTestCaseIds(allMainTestData[index].subTestCases[0].id);
  };
  const selectDevice = (e) => {
    setSelectedDevice(
      typeof e.target.value === "string"
        ? e.target.value.split(",")
        : e.target.value
    );
  };
  const selectSubTestCase = (e) => {
    const subTestCases = e.target.value;
    setSelectedSubTestCase(subTestCases);
    setFilteredSubTestCaseIds(subTestCases.map(value => {
      return value.id
    }));

  };
  const selectTestCondition = (e) => {
    setSelectedTestCondition(e.target.value);
  };

  const removeDevice = (device) => {
    let newSelectedDevices = [];
    selectedDevice.map((d) => {
      if (d !== device) {
        newSelectedDevices.push(d);
      }
    });
    setSelectedDevice(newSelectedDevices);
  };

  const removeSelectedSubTestCase = (testCase) => {
    let newSelectedSubTestCase = [];
    selectedSubTestCase.map((test) => {
      if (test.id !== testCase) {
        newSelectedSubTestCase.push(test);
      }
    });
    setSelectedSubTestCase(newSelectedSubTestCase);
    setFilteredSubTestCaseIds(selectedSubTestCase.filter(value => value.id !== testCase));
  };
  const removeTestCondition = (condition) => {
    let newTestConditions = [];
    selectedTestCondition.map((c) => {
      if (c !== condition) {
        newTestConditions.push(c);
      }
    });
    setSelectedTestCondition(newTestConditions);
  };

  useEffect(() => {
    let allbatches;
    const allBatches = async () => {
      allbatches = await getAllBatches();
      if (allbatches !== undefined) {
        setBatches(allbatches);
        setPreviousBatch("");
        const mainTestCasesData = await getAllMainTestCases(0);
        if (
          mainTestCasesData !== undefined &&
          mainTestCases !== null &&
          mainTestCasesData.data.length > 0 &&
          mainTestCasesData.mainTestCases.length > 0
        ) {
          setMainTestCases(mainTestCasesData.mainTestCases);
          setAllMainTestData(mainTestCasesData.data);
          setSelectedMainTestCase(mainTestCasesData.data[0].id);
          setSelectedMainDefaultTestCase(mainTestCasesData.data[0].id);
          setMainTestCaseTitle(mainTestCasesData.data[0].mainTestTitle);
          setAllSubTestCases(mainTestCasesData.data[0].subTestCases);
        }
      }
    };

    const dataTableMainCases = async () => {
      const dataMainCases = await getAllDefaultMainTestCases();
      setDataTableMainTestCases(dataMainCases.mainTestCases);
    };

    const allDevices = async () => {
      const data = await getAllDevices('LIST');
      let newDevices = [];
      if (data && data.content) {
        data.content.map((d) => {
          if (d.batchNumber == allbatches[0]) {
            newDevices.push(d);
          }
        });
        setConstDevices(data.content);
      }
    };
    const allTest = async () => {
      const allTestCondition = await getTestCondition();
      if (allTestCondition !== undefined) {
        setAllTestConditions(allTestCondition);
      }
    };

    allBatches();
    allDevices();
    allTest();
    dataTableMainCases();

    if (step === "device") {
      setSelectedBatch("Select the batch")
      setSelectedMainTestCase("Select the test case")
    }
    setSelectedDevice([])
    setSelectedSubTestCase([])
    setSelectedTestCondition([])
    setStartDate("")
    setEndDate("")
  }, [step]);


  const handleStartDateChange = (e) => {
    const newStartDate = formatDateString(e)
    if (newStartDate > endDate) {
      setEndDate("");
      setSelectedEndDate(new Date())
    }
    console.log(newStartDate)
    setStartDate(newStartDate);
    setSelectedStartDate(e)
  };

  const handleEndDateChange = (e) => {
    const newEndDate = formatDateString(e)
    if (newEndDate < startDate) {
      setStartDate("");
      setSelectedStartDate(new Date())
    }
    console.log(newEndDate)
    setEndDate(newEndDate);
    setSelectedEndDate(e)
  };

  const handleTestDashboardClick = async (mainTestTitle) => {
    setLoading(true);
    setStep("test");
    console.log(selectedBatch)
    try {
      if (selectedBatch != "" && selectedBatch !== "Select the batch") {
        setLoadingTestSummary(true); // Set loading state for testSummary to true
        const testSummary = await getDeviceTestSummery(selectedBatch, mainTestTitle);
        setTestSummary(testSummary);
        setPreviousBatch(selectedBatch);
        const testSuccessCriteria = await getAllMainTestCases(selectedBatch);

        if (testSuccessCriteria != undefined) {
          setTestSuccessData(testSuccessCriteria.data);
          setSelectedMainTestCase(testSuccessCriteria.data[0].id);
        }
      }
    } catch (error) {
      console.error("Error fetching testSummary:", error);
    } finally {
      setLoadingTestSummary(false); // Set loading state for testSummary to false
    }

    setLoading(false);
  };

  const handleDeviceDashBoardClick = async () => {
    setStep("device");
    const mainTestCasesData = await getAllDefaultMainTestCases();

    if (mainTestCasesData !== undefined) {
      setMainTestCases(mainTestCasesData.mainTestCases);
      setAllMainTestData(mainTestCasesData.data);
    }
  };

  return (
    <div className={`testing`}>
      <div
        className="page-heading"
        style={{
          marginBottom: "50px",
        }}
      >
        Testing Automation
      </div>
      {(loading || loadingTestSummary) && (
        <div
          style={{
            position: "fixed", // Change from "absolute" to "fixed"
            top: 0,
            left: 0,
            width: "100vw", // Use viewport width
            height: "100vh", // Use viewport height
            backgroundColor: "#000000",
            opacity: 0.5,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <CircularProgress size={80}/>
        </div>
      )}
      <Grid container>
        <Grid
          item
          xs={4}
          md={4}
          onClick={handleDeviceDashBoardClick}
          className={classes.navButtons}
          style={{
            backgroundColor: step === "device" ? white : "#ECEDEF",
            color: step === "device" ? primaryBlue : "inherit",
            boxShadow: step === "device"? " 0 2px 8px #0000000A": "none",
          }}
        >
          Setup Testing
        </Grid>
        <Grid
          item
          xs={4}
          md={4}
          onClick={() => setStep("parameter")}
          className={classes.navButtons}
          style={{
            backgroundColor: step === "parameter" ? white : "#ECEDEF",
            color: step === "parameter" ? primaryBlue : "inherit",
            boxShadow: step === "parameter"? " 0 2px 8px #0000000A": "none",
          }}
        >
          Setup Parameters
        </Grid>
        <Grid
          item
          xs={4}
          md={4}
          onClick={() => handleTestDashboardClick("Continuous Transmission Test")}
          className={classes.navButtons}
          style={{backgroundColor: step === "test" ? white : "#ECEDEF",
          color: step === "test" ? primaryBlue : "inherit",
          boxShadow: step === "test"? " 0 2px 8px #0000000A": "none",
          }}
          
        >
          Test Report
        </Grid>

        <Grid item xs={12} md={3} style={{textAlign: "left", margin: "20px"}}>
          <Typography className={classes.text}>Select the batch</Typography>
          <FormControl className={classes.dropdown} disabled={step === "parameter"}>
            <NativeSelect
              id="demo-customized-select-native"
              value={selectedBatch}
              className={classes.dropdown}
              onChange={selectBatch}
              input={<BootstrapInput/>}
            >
              <option value="">Select the batch</option>
              {batches.map((batch, index) => {
                return (
                  <option key={index} value={batch}>
                    {batch}
                  </option>
                );
              })}
            </NativeSelect>
          </FormControl>
        </Grid>
        {step === "test" || step === "parameter" ? (
          <Grid
            item
            xs={12}
            md={3}
            style={{textAlign: "left", margin: "20px"}}
          >
            {
              step === "parameter" && <>
                <Typography className={classes.text}>Select Test Cases</Typography>
                <TextBar error={{error: false, errorMsg: ""}}
                         disabled defaultValue={subTestCasesOfTheTest.mainTestTitle}/>
              </>
            }
          </Grid>
        ) : (
          <>
            <Grid
              item
              xs={12}
              md={selectedDevice.length > 2 ? 12 : 3}
              style={{textAlign: "left", margin: "20px"}}
            >
              <Typography className={classes.text}>
                Current device configuration
              </Typography>
              <FormControl className={classes.dropdown}>
                <Select
                  id="demo-customized-select-native"
                  value={selectedDevice}
                  MenuProps={{
                    anchorOrigin: {
                      vertical: "bottom",
                      horizontal: "left",
                    },
                    transformOrigin: {
                      vertical: "top",
                      horizontal: "left",
                    },
                    getContentAnchorEl: null,
                    classes: {paper: classes.menuPaper},
                  }}
                  className={classes.dropdown}
                  onChange={selectDevice}
                  multiple
                  renderValue={(selected: string[]) => (
                    <div>
                      {selected.map((value, i) => (
                        <Chip
                          key={i}
                          label={value}
                          className={classes.chip}
                          onMouseDown={(event) => {
                            event.stopPropagation();
                          }}
                          onDelete={() => removeDevice(value)}
                        />
                      ))}
                    </div>
                  )}
                  input={<BootstrapInput/>}
                >
                  {devices !== undefined &&
                    devices.map((device, index) => {
                      return (
                        <MenuItem key={index} value={device.id}>
                          <Checkbox
                            checked={selectedDevice.includes(device.id)}
                            style={{color: "#8F8F8F", display: "inline"}}
                          />
                          <ListItemText primary={device.name}/>
                        </MenuItem>
                      );
                    })}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={selectedDevice.length > 2 ? 1 : 3}></Grid>
            <Grid
              item
              xs={12}
              md={3}
              style={{textAlign: "left", margin: "20px"}}
            >
              <Typography className={classes.text}>
                Configure the main test case
              </Typography>
              <FormControl className={classes.dropdown}>
                <NativeSelect
                  id="demo-customized-select-native"
                  value={selectedMainTestCase}
                  className={classes.dropdown}
                  onChange={selectMainTestCase}
                  input={<BootstrapInput/>}
                >
                  {allMainTestData.map((mainCase, index) => {
                    return (
                      <option key={index} value={mainCase.id}>
                        {mainCase.mainTestTitle}
                      </option>
                    );
                  })}
                </NativeSelect>
              </FormControl>
            </Grid>
            <Grid
              item
              xs={12}
              md={selectedSubTestCase.length > 1 ? 12 : 3}
              style={{textAlign: "left", margin: "20px"}}
            >
              <Typography className={classes.text}>
                Configure a sub test case
              </Typography>
              <FormControl className={classes.dropdown}>
                <Select
                  id="demo-customized-select-native"
                  value={selectedSubTestCase}
                  MenuProps={{
                    anchorOrigin: {
                      vertical: "bottom",
                      horizontal: "left",
                    },
                    transformOrigin: {
                      vertical: "top",
                      horizontal: "left",
                    },
                    getContentAnchorEl: null,
                    classes: {paper: classes.menuPaper},
                  }}
                  className={classes.dropdown}
                  onChange={selectSubTestCase}
                  multiple
                  renderValue={(selected: { id: string, subTestTitle: string }[]) => (
                    <div>
                      {selected.map((value, i) => (
                        <Chip
                          key={i}
                          label={value.subTestTitle}
                          className={classes.chip}
                          onMouseDown={(event) => {
                            event.stopPropagation();
                          }}
                          onDelete={() => i !== 0 && removeSelectedSubTestCase(value.id)}
                        />
                      ))}
                    </div>
                  )}
                  input={<BootstrapInput/>}
                >
                  {allSubTestCases !== undefined &&
                    allSubTestCases.map((sub, index) => {
                      return (
                        <MenuItem key={index} value={sub} disabled={index === 0}>
                          <Checkbox
                            checked={selectedSubTestCase.some(e => e.id === sub.id)}
                            style={{color: "#8F8F8F", display: "inline"}}
                          />
                          <ListItemText primary={sub.subTestTitle}/>
                        </MenuItem>
                      );
                    })}
                </Select>
              </FormControl>
            </Grid>
            <Grid
              item
              xs={12}
              md={selectedTestCondition.length > 1 ? 12 : 4}
              style={{textAlign: "left", margin: "20px"}}
            >
              <Typography className={classes.text}>
                Configure a test condition
              </Typography>
              <FormControl className={classes.dropdown}>
                <Select
                  id="demo-customized-select-native"
                  value={selectedTestCondition}
                  MenuProps={{
                    anchorOrigin: {
                      vertical: "bottom",
                      horizontal: "left",
                    },
                    transformOrigin: {
                      vertical: "top",
                      horizontal: "left",
                    },
                    getContentAnchorEl: null,
                    classes: {paper: classes.menuPaper},
                  }}
                  className={classes.dropdown}
                  onChange={selectTestCondition}
                  multiple
                  renderValue={(selected: string[]) => (
                    <div>
                      {selected.map((value, i) => (
                        <Chip
                          key={i}
                          label={value}
                          className={classes.chip}
                          onMouseDown={(event) => {
                            event.stopPropagation();
                          }}
                          onDelete={() => removeTestCondition(value)}
                        />
                      ))}
                    </div>
                  )}
                  input={<BootstrapInput/>}
                >
                  {allTestConditions !== undefined &&
                    allTestConditions.map((test, index) => {
                      return (
                        <MenuItem key={index} value={test}>
                          <Checkbox
                            checked={selectedTestCondition.includes(test)}
                            style={{color: "#8F8F8F", display: "inline"}}
                          />
                          <ListItemText primary={test}/>
                        </MenuItem>
                      );
                    })}
                </Select>
              </FormControl>
            </Grid>
            <Grid
              item
              xs={12}
              md={3}
              style={{textAlign: "left", margin: "20px"}}
            >
              <Typography className={classes.text}>Start time</Typography>
              <DateTimeSelectorComponent selectedDate={selectedStartDate} handleDateChange={handleStartDateChange}/>
            </Grid>
            <Grid
              item
              xs={12}
              md={3}
              style={{textAlign: "left", margin: "20px"}}
            >
              <Typography className={classes.text}>End time</Typography>
              <DateTimeSelectorComponent selectedDate={selectedEndDate} handleDateChange={handleEndDateChange}/>
            </Grid>
          </>
        )}
        <Grid item md={7}></Grid>

        <Grid item xs={12} md={12}>
          {step === "test" ? (
            <div>
              {allMainTestData.length > 0 && step === "test" ? (
                <TestDashboard
                  mainTestCase={selectedMainTestCase}
                  allMainTestCases={mainTestCases}
                  allData={testSuccessData}
                  testSummaryData={testSummary}
                  loadingClose={() => {
                    setLoading(false);
                  }}
                  dataTableMainTestCases={dataTableMainTestCases}
                  handleTestDashboardClick={(mainTitle) => handleTestDashboardClick(mainTitle)}
                />
              ) : (
                <></>
              )}
            </div>
          ) : step === "parameter" ? (
            <div>
              <ParameterConfig
                subTestCasesOfTheTest={subTestCasesOfTheTest}
                batch={selectedBatch}
                mainTestId={selectedMainDefaultTestCase}
                subTestCaseIds={filteredSubTestCaseIds}
              />
              <Grid container>
                <Grid item xs={6} md={6}></Grid>
                <Grid
                  item
                  xs={6}
                  md={6}
                  style={{textAlign: "right", padding: "10px"}}
                >
                  <Button className={style.saveButton}
                    onClick={() => handleTestDashboardClick("Continuous Transmission Test")}
                  >
                    Next
                  </Button>
                </Grid>
              </Grid>
            </div>
          ) : (
            <div style={{margin: "20px"}}>
              {allMainTestData.length > 0 ? (
                <DeviceConfig
                  onClick={() => cancel()}
                  selectedSubTestCase={selectedSubTestCase}
                  setSubTestCasesForParameter={(subs) => setSubTestCasesForParameter(subs)}
                  startDate={startDate}
                  endDate={endDate}
                  testCondition={selectedTestCondition}
                  batch={selectedBatch}
                  devicesData={selectedDevice}
                  mainTestCase={selectedMainTestCase}
                  subTestCase={filteredSubTestCaseIds}
                  allData={allMainTestData}
                  onNavigateToNextStep={() => setStep("parameter")}
                />
              ) : (
                <></>
              )}
            </div>
          )}
        </Grid>
      </Grid>
    </div>
  );
};

//Bootstrap like dropdown component
const BootstrapInput = withStyles((theme: Theme) =>
  createStyles({
    root: {
      "label + &": {
        marginTop: theme.spacing(3),
      },
    },
    input: {
      borderRadius: 4,
      position: "relative",
      backgroundColor: "#F4F5F7",
      border: "1px solid #ced4da",
      fontSize: 16,
      padding: "10px 26px 10px 12px",
      transition: theme.transitions.create(["border-color", "box-shadow"]),
      // Use the system font instead of the default Poppins font.
      fontFamily: [
        "-apple-system",
        "BlinkMacSystemFont",
        '"Segoe UI"',
        "Poppins",

        "Arial",
        "sans-serif",
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(","),
      "&:focus": {
        borderRadius: 4,
        borderColor: "#80bdff",
        boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
      },
    },
  })
)(InputBase);
